<button type="button" class="c-button c-button--link c-button--link-primary-lg px-0" data-di-id="di-id-41a05d18-6b04a424"
        [routerLink]="['/my-account/make-payment']"
>
  {{ translation() }}
</button>
